import { CategoryUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/inventory/v1/category_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

type CategoryUpdatedDetailProps = {
  event: CategoryUpdatedEvent;
};

export const CategoryUpdatedDetail = ({
  event,
}: CategoryUpdatedDetailProps) => {
  const previous = event.previousCategory;
  const current = event.updatedCategory;

  if (!previous || !current) {
    return (
      <Col className="@CategoryUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const previousAttributes = previous.attributes as
    | Record<string, unknown>
    | undefined;
  const currentAttributes = current.attributes as
    | Record<string, unknown>
    | undefined;
  const previousAttributesCount = previousAttributes
    ? Object.keys(previousAttributes).length
    : 0;
  const currentAttributesCount = currentAttributes
    ? Object.keys(currentAttributes).length
    : 0;

  const diffs = [
    {
      field: 'name',
      label: 'Name',
      previous: previous.name,
      current: current.name,
    },
    {
      field: 'description',
      label: 'Description',
      previous: previous.description,
      current: current.description,
    },
    {
      field: 'organizationId',
      label: 'Organization ID',
      previous: previous.base?.organizationId?.value,
      current: current.base?.organizationId?.value,
    },
    {
      field: 'attributesCount',
      label: 'Attributes Count',
      previous: String(previousAttributesCount),
      current: String(currentAttributesCount),
    },
  ];

  return (
    <Col className="@CategoryUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Category</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay label="Name" value={current.name} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
